import { isEmpty } from 'lodash';
import { APP_CONFIG, BUY_E_FORM, GET_ESIM_ACTIVATION_CODE, STAFF_CHECK_ELIGIBILITY } from '@/config/common';
import TokenService from './tokenService';
import { Imenu } from '@/pages/home/models/homeModel';
import { userPolicyFeatureCode, userPolicyMenu } from '@/config/userGroupPolicy';
import { getSERUserPermission, getUserPermission } from './userGroupPolicy';

import { initialState as accountInitialState } from '@/reducers/account';
import { initialState as authInitialState } from '@/reducers/auth';
import { initialState as cartInitialState } from '@/reducers/cart';
import { initialState as catalogueInitialState } from '@/reducers/catalogue';
import { initialState as changeNumberInitialState } from '@/reducers/changemobileno';
import { initialState as checkeligibilityInitialState } from '@/reducers/checkeligibility';
import { initialState as checkoutInitialState } from '@/reducers/checkout';
import { initialState as commonInitialState } from '@/reducers/common';
import { initialState as contractInitialState } from '@/reducers/contract';
import { initialState as numberPortInitialState } from '@/reducers/numberPort';
import { initialState as numberShareInitialState } from '@/reducers/numberShare';
import { initialState as orderInitialState } from '@/reducers/order';
import { initialState as promoConfigsInitialState } from '@/reducers/promoConfigs';
import { initialState as reservenumberInitialState } from '@/reducers/reservenumber';
import { initialState as serroadshowInitialState } from '@/reducers/serroadshow';
import { initialState as transferlineInitialState } from '@/reducers/transferline';


export const isBrowser = () => {
  if (typeof window !== 'undefined' || typeof window !== undefined) return true;
  return false;
}

export const getMatchSIMonly = (item) => {
  const test1 = /sim/i.test(item);
  const test2 = /only/i.test(item);
  if (test1 && test2) return true;
  return false;
};

export const getCustomerFlow = () => {
  return getLocalStorageData('customer_flow') || 'NEWLINE'
}

export const getMobileShare = (pricePlanGroupId, pricePlan) => {
  if (pricePlanGroupId === APP_CONFIG.MOBILESHARE_PLAN) return true;
  if (pricePlan?.planTypeCode === 'Mobileshare') return true;
  return false;
};

export const checkNumberPoolingPlan = (pricePlanGroupId = '') => {
  if (pricePlanGroupId === APP_CONFIG.NUMBER_POOLING_PLAN) return true;
  return false;
};


export const getSvcNumsWithErr = (serviceNumbers) => {
  return serviceNumbers?.filter(({ error = {} }) => !isEmpty(error));
};

export const getDisabledSvcNums = (serviceNumbers) => {
  const svcNumsWithErr = getSvcNumsWithErr(serviceNumbers);
  return svcNumsWithErr?.map((svcNum) => svcNum.number) || [];
};

export const getSvcNumErrCode = (serviceNumbers, t) => {
  const svcNumsWithErr = getSvcNumsWithErr(serviceNumbers);
  if (!isEmpty(svcNumsWithErr)) {
    const { error = {} } = svcNumsWithErr[0];
    if (t(error.code) === error.code) {
      return error.message || error.code;
    }
    return svcNumsWithErr.length > 1 ? 'SERVICE_NUMBERS_NOT_AVAILABLE' : 'SERVICE_NUMBER_NOT_AVAILABLE';
  }
};

export const navLinks = {
  myEmpowersite: process.env.GATSBY_UDF_SIT_URL ? process.env.GATSBY_UDF_SIT_URL : '',
  gatsbyLogoutUrl: process.env.GATSBY_UDF_SIT_URL ? `${process.env.GATSBY_UDF_SIT_URL}logout` : '',
  numberShareRedirectUrl: process.env.GATSBY_NUMBER_SHARE_URL ? process.env.GATSBY_NUMBER_SHARE_URL : ''
};

export const returnObject = (object) => {
  return object || {};
};

export const getGlobalConfig = (globalConfigsList, config) => {
  if (globalConfigsList && globalConfigsList[config]) return globalConfigsList[config];
  return undefined;
};

export const checkPdpaEnabled = (auth) => {
  if (typeof window !== 'undefined') {
    if (window.sessionStorage && window.sessionStorage.getItem('_userType') === 'PDPA') return true;
  }
  if (auth?.key !== undefined && auth.key?.length > 0) return true;
  return false;
};

const getRequestData = (data) => {
  return data ?? '';
};

export const getPdpaOrderData = (pdpaOrder) => {
  let pdpaOrderDetail = {
    requesterName: getRequestData(pdpaOrder?.requesterName),
    requesterLastName: getRequestData(pdpaOrder?.requesterLastName),
    requesterServiceNumber: getRequestData(pdpaOrder?.requesterServiceNumber),
    requesterEmail: getRequestData(pdpaOrder?.requesterEmail),
    purchaseFocalScopeId: getRequestData(pdpaOrder?.purchaseFocalScopeId),
    purchaseOrderNumber: getRequestData(pdpaOrder?.purchaseOrderNumber),
    businessUnitCode: getRequestData(pdpaOrder?.businessUnitCode),
    deliveryReceipientName: getRequestData(pdpaOrder?.deliveryDetail?.name),
    deliveryReceipientMobile: getRequestData(pdpaOrder?.deliveryDetail?.mobile),
    deliveryReceipientEmail: getRequestData(pdpaOrder?.deliveryDetail?.email),
    tcAgreed: true,
    requesterIsCmoUser: pdpaOrder?.requesterIsCmoUser || false,
    customerId: getRequestData(pdpaOrder?.customerId),
    deliveryDetail: {
      type: getRequestData(pdpaOrder?.deliveryType),
      deliveryDate: getRequestData(new Date(pdpaOrder?.deliveryDate).getTime()),
      deliveryTimeSlotDate: getRequestData(pdpaOrder?.deliveryTimeSlot),
      name: getRequestData(pdpaOrder?.deliveryDetail?.name),
      email: getRequestData(pdpaOrder?.deliveryDetail?.email),
      mobile: getRequestData(pdpaOrder?.deliveryDetail?.mobile),
      postalCode: getRequestData(pdpaOrder?.deliveryDetail?.postalCode),
      houseBlockNumber: getRequestData(pdpaOrder?.deliveryDetail?.houseBlockNumber),
      buildingName: getRequestData(pdpaOrder?.deliveryDetail?.buildingName),
      streetName: getRequestData(pdpaOrder?.deliveryDetail?.streetName),
      POPStationName: getRequestData(pdpaOrder?.deliveryDetail?.POPStationName),
      unitNumber: getRequestData(pdpaOrder?.deliveryDetail?.unitNumber)
    },
    price: pdpaOrder?.price,
    paymentDetail: {
      paymentTypeToday: pdpaOrder?.paymentTypeTodaysCharge,
      billingAccount: pdpaOrder?.billingAccount || {}
    },
    shoppingCartId: getRequestData(pdpaOrder?.shoppingCartId),
    brn: getRequestData(pdpaOrder?.brn),
    transactionType: getRequestData(pdpaOrder?.transactionType),
    amountTodayCalculateCharge: pdpaOrder?.price?.totalTodaysCharge || 0,
    orderId: getRequestData(pdpaOrder?.orderId),
    createdBy: getRequestData(pdpaOrder?.createdBy)
  }
  if (pdpaOrder?.portInDate) pdpaOrderDetail['portInDate'] = getRequestData(pdpaOrder.portInDate)
  if (pdpaOrder?.deliveryChargeForOrderDto) pdpaOrderDetail['deliveryChargeForOrderDto'] = pdpaOrder.deliveryChargeForOrderDto
  if (pdpaOrder?.waiverRequested !== undefined) pdpaOrderDetail['waiverRequested'] = pdpaOrder.waiverRequested
  if (pdpaOrder?.waiverRequestComments !== undefined) {
    if (pdpaOrder?.orderStatus) pdpaOrderDetail['orderStatus'] = pdpaOrder.orderStatus
    pdpaOrderDetail['deliveryDetail']['resAddress'] = pdpaOrder?.deliveryDetail?.resAddress
    pdpaOrderDetail['waiverRequestComments'] = pdpaOrder.waiverRequestComments
  }
  return pdpaOrderDetail;
}

export const getPayloadParams = (params) => {
  const queryString = Object.keys(params).map((key) => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
  }).join('&');
  return queryString
}

export const isObjectEmpty = (objectName) => {
  if (objectName === undefined) return true;
  return JSON.stringify(objectName) === '{}';
};

export const checkUDFTokenExpired = () => {
  const getCurrentTime = new Date().getTime();
  if (TokenService.getLocalTokenData().expiryAt !== 0 && TokenService.getLocalTokenData().expiryAt < getCurrentTime)
    return true;
  return false;
};

export const getLocalStorageData = (item) => {
  return typeof window !== 'undefined' && window.localStorage.getItem(item);
}

export const isEmpowerFlow = () => {
  if (getLocalStorageData('udf_token')) return true;
  return false;
}

export const isMyEmpowerFlow = () => {
  if (getLocalStorageData('myudf_token')) return true;
  const siteUrl = process.env.GATSBY_UDF_SIT_URL || '';
  const substr = 'myempower';
  if (siteUrl.includes(substr)) return true;
  return false;
}

// Adding template menu we get from API and if SPOC option to create template
export const getSmartTemplateMenuList = (createEnable, smartTemplateMenus, userPolicy) => {
  const smartTemplateMenuList: Imenu[] = []
  if (createEnable && getUserPermission(userPolicyFeatureCode.SMT_TEMPLATE_CREATE, userPolicy)) {
    smartTemplateMenuList.push({
      title: 'Create/Manage Smart Template',
      url: '/smarttemplate',
      orderType: ''
    })
  }
  if (smartTemplateMenus.length > 0 && getUserPermission(userPolicyFeatureCode.SMT_TEMPLATE_BUY, userPolicy)) {
    smartTemplateMenuList.push({
      title: 'Purchase Smart Template',
      url: '/purchasesmarttemplate',
      orderType: ''
    })
  }
  return smartTemplateMenuList
}

export const getFormPermission = (userPolicy) => {
  const eFormList: Imenu[] = []
  if (getUserPermission(userPolicyFeatureCode.BUY_E_FORM, userPolicy)) {
    eFormList.push({
      title: 'eForm',
      url: '/eform',
      orderType: BUY_E_FORM
    })
  }
  return eFormList
}
const getReserveNumberPermission = (isCmoUser, brnConfig, userPolicy) => {
  if (isCmoUser && brnConfig['ALLOWED_TO_RESERVE_NUMBER']) {
    return getUserPermission(userPolicyFeatureCode.RESERVE_NUMBER, userPolicy)
  }
  return false
}

export const getMenuItemFilter = (item, brnConfig, isCmoUser, isStaffLogin, userPolicy) => {
  // const eSIMEligibleBrn = brnConfig['IS_ESIM_ELIGIBLE'] === 'true';
  const isStaffPurchanse = brnConfig['IS_STAFF_PURCHASE'] === 'true';
  if (item.orderType === STAFF_CHECK_ELIGIBILITY && !(isEmpowerFlow() || isStaffLogin) && isStaffPurchanse) return true;
  if (item.orderType === GET_ESIM_ACTIVATION_CODE && (isCmoUser)) return true;
  // if (isStaffLogin && ![NEWLINE, RECONTRACT, REPLACE_SIM, CEASE_ADDONS, STAFF_CHECK_ELIGIBILITY,ACTIVATE_SIM].includes(item.orderType || '')) return false;
  if (item.title === 'Reserve Number') return getReserveNumberPermission(isCmoUser, brnConfig, userPolicy);
  if (item.title === 'SER Roadshow') return getSERUserPermission(userPolicy);
  if (item.title === 'Catalogue') return getUserPermission(userPolicyFeatureCode.VIEW_CATALOGUE, userPolicy);
  if (item.title === 'Check Eligibility') return getUserPermission(userPolicyFeatureCode.USER_PLANS, userPolicy);

  const featureItem = userPolicyMenu.find((menu) => menu.ordertype === item.orderType)
  if (featureItem?.featureCode) {
    return getUserPermission(featureItem.featureCode, userPolicy)
  }
  return false
}

export const getConfigurationValue = (item) => {
  let itemValue: string | number | boolean | null;
  const booleanConfig = ['POPSTATION_DELIVERY', 'ALLOW_SPLIT_PAYMENT', 'RESIDENTIAL_DELIVERY', 'ALLOW_FOR_HOME_DELIVERY', 'ALLOWED_TO_RESERVE_NUMBER'];
  const numberConfig = ['MAX_DEVICE_FOR_RESIDENTIAL_DELIVERY', 'DAYS_LIMIT_FOR_RESERVED_NUMBERS', 'MAXIMUM_RESERVED_NUMBERS', 'MAX_DEVICE_FOR_POPSTATION_DELIVERY']
  if (booleanConfig.includes(item.keyName)) {
    itemValue = ['ON', 'true'].includes(item.keyValue) ? true : false;
  } else if (numberConfig.includes(item.keyName)) {
    itemValue = item.keyValue ? Number(item.keyValue) : 0;
  } else {
    itemValue = item.keyValue
  }
  return itemValue
}

export const checkCurrentDateBetweenRange = (startDate, endDate) => {
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  const newStartDate = new Date(startDate);
  newStartDate.setHours(0, 0, 0, 0);
  const newEndDate = new Date(endDate);
  newEndDate.setHours(0, 0, 0, 0);
  if (newStartDate.getTime() <= currentDate.getTime() &&
    newEndDate.getTime() >= currentDate.getTime() &&
    newStartDate.getTime() <= newEndDate.getTime()) {
    return true
  }
  return false;
}

export const makeUniqueArray = (array = [], keys: string[] = []) => {
  if (!keys.length || !array.length) return [];

  return array.reduce((list, item) => {
    const hasItem = list.find(listItem =>
      keys.every(key => listItem[key] === item[key])
    );
    if (!hasItem) list.push(item);
    return list;
  }, []);
};

export const isDailyBaseAddOn = (title: string) => (title ? (title === "BDR UL") : false)

export const defaultStore = {
  auth: authInitialState,
  account: accountInitialState,
  cart: cartInitialState,
  catalogue: catalogueInitialState,
  changeNumber: changeNumberInitialState,
  checkEligibility: checkeligibilityInitialState,
  checkout: checkoutInitialState,
  common: commonInitialState,
  contract: contractInitialState,
  numberPort: numberPortInitialState,
  numberShare: numberShareInitialState,
  order: orderInitialState,
  promoConfigs: promoConfigsInitialState,
  reservenumber: reservenumberInitialState,
  transferLine: transferlineInitialState,
  serRoadshow: serroadshowInitialState
}
